// Données du joueur sur l'appareil (le login est retiré en version 1 : plus de profil, d'avatar ni de lieu). Seule reste la réinitialisation.
import { STORAGE_KEYS } from '../config/constants.js';
import { removeLocal } from './storage.js';

/** @param {{ remove?: Function }} [storage]  injectable pour les tests */
export function createAccount({ remove = removeLocal } = {}) {
  return {
    /**
     * Réinitialisation : efface galerie, récompenses du partage, charge en cours, niveau, meilleur score, astuces vues, et les anciennes données du login
     * (profil, lieu de démo, solde de pièces) ; garde les réglages, la langue et le volume.
     */
    reset() {
      for (const key of ['profile', 'demoPlace', 'credits', 'shareRewards', 'iosFreeFastLevel', 'gallery', 'chargingUntil', 'longLife', 'level', 'gameWon', 'bestScore', 'tipsSeen']) {
        remove(STORAGE_KEYS[key]);
      }
    },
  };
}
